import React from "react";
import { Box } from "@mui/material";

export function Header({ children }: { children: React.ReactNode }) {
  return <Box>{children}</Box>;
}
